<template>
  <router-link class="logo relative z-10" to="/">
    <img src="../../assets/images/logo/Fuchsjobs-Logo_Farbe-_klein.png" class="h-[68px] sm:h-[80px] mt-3 sm:mt-0 inline-block dark:hidden" alt="">
    <img src="../../assets/images/logo/Fuchsjobs_Logo_schwarzweiss.svg" class="h-[68px] sm:h-[80px] mt-3 sm:mt-0 hidden dark:inline-block" alt="">
  </router-link>
</template>
